export default {
  breakpoints: {
    ExtraSmall: {
      label: 'extra-small',
      lowerbound: 0,
      upperbound: 325
    },
    Small: {
      label: 'small',
      lowerbound: 325,
      upperbound: 831
    },
    Medium: {
      label: 'medium',
      lowerbound: 832,
      upperbound: 1023
    },
    Large: {
      label: 'large',
      lowerbound: 1024,
      upperbound: 2100
    },
    ExtraLarge: {
      label: 'extra-large',
      lowerbound: 2100,
      upperbound: 1000000
    }
  }
};
